import {pageInfo, initPage, saveData,initUpdate, editData,deleteData,exportData,
  orderBasicDetailsInfo,initOrderApprovedData,fileDownload,approveAgree, batchApproveAgree,
  refuseApproved, templateItr, uploadUrl, uploadItr, uploadItrResult, dehire, templateDomesticOrder,
  uploadDomesticOrder, uploadDomesticOrderResult, uploadOrder, templateOrder, uploadOrderResult,
  templateDehire, uploadDehire, uploadDehireResult} from './../api';
import {
  selectRecyclingOrderStatus, selectOrderType, selectOrderRejectReason,
  findRecyclingOrderType, selectMinqtyByCustomerno, findValidAddrsByCustomerCode, findConsigneesByCustomerCode
} from "../../../../api";
import { findListByCustomerAndSku } from '../api'
const salesApprove = {
  namespaced: true,
  state: {
    total:0,
    pageResp:null,
    addResp: null,
    editResp: null,
    initPageObj: null,
    initUpdateObj: null,
    deleteResp: null,
    exportObj: null,
    orderBasicInfoObj :null,
    orderListObj:null,
    fileObj: null,
    agreeObj: null,
    batchAgreeObj: null,
    refuseObj: null,
    orderStatusObj: null,
    orderTypeObj: null,
    orderRejectReasonObj:null,
    templateItrData: null,
    uploadUrlObj: null,
    uploadItrData: null,
    uploadItrResultObj:null,
    dehireData: null,
    templateDomesticOrderObj: null,
    uploadDomesticOrderResp: null,
    uploadDomesticOrderResultObj: null,
    uploadOrderResp: null,
    templateOrderObj: null,
    uploadOrderResultObj: null,
    findRecyclingOrderTypeData: null,
    selectMinqtyByCustomernoData: null,
    consigneecAddrsObj: null,
    consigneesObj: null,
    skuResp: null,
    templateDehireData: null,
    uploadDehireData: null,
    uploadDehireResultObj: null
  },
  mutations: {

    PAGE_INFO(state,data){
      state.total = data.total;
      state.pageResp = data.obj || [];
      state.pageResp.map(item=>{
        item.showBtnIcon = item.schOrderWarnPOS.length > 0 ? true :false
      })
    },
    INIT_PAGE(state,data) {
      state.initPageObj = data.obj || {};
    },
    SAVE_DATA(state,data){
      state.addResp = data;
    },
    INIT_UPDATE(state,data) {
      state.initUpdateObj = data.obj || {};
    },
    EDIT_DATA(state,data){
      state.editResp = data;
    },
    DELETE_DATA(state,data){
      state.deleteResp = data;
    },
    EXPORT_DATA(state, data) {
      state.exportObj = data;
    },

    ORDERBASIC_DETAILS_INFO(state, resp) {
      state.orderBasicInfoObj = resp.obj || {};
    },
    ORDER_LIST(state, data){
      state.orderListObj = data;
    },
    FILE_DATA(state, data) {
      state.fileObj = data;
    },
    AGREE_DATA(state, data) {
      state.agreeObj = data;
    },
    BATCH_AGREE_DATA(state, data) {
      state.batchAgreeObj = data;
    },
    REFUSE_DATA(state, data) {
      state.refuseObj = data;
    },
    ORDER_STATUS(state,data){
      state.orderStatusObj = data.obj || {};
    },
    ORDER_TYPE(state,data){
    state.orderTypeObj = data.obj || {};
    },
    ORDER_REJECT_REASON(state,data){
      state.orderRejectReasonObj = data.obj || {};
    },
    TEMPLATE_ITR_DATA(state,data){
      state.templateItrData = data;
    },
    UPLOAD_URL_DATA(state,data){
      state.uploadUrlObj = data;
    },
    UPLOAD_ITR_DATA(state,data){
      state.uploadItrData = data;
    },
    UPLOAD_ITR_RESULT(state, data) {
        state.uploadItrResultObj = data;
    },
    DEHIRE_DATA(state, data) {
      state.dehireData = data;
    },
    DOWNLOAD_DOMESTIC_ORDERTEMPLATE(state, data) {
      state.templateDomesticOrderObj = data
    },
    UPLOAD_DOMESTIC_ORDERDATA(state, data) {
      state.uploadDomesticOrderResp = data
    },
    UPLOAD_ORDER_RESULT(state, data) {
      state.uploadOrderResultObj = data
    },
    UPLOAD_DOMESTICORDER__RESULT(state, data) {
      state.uploadDomesticOrderResultObj = data
    },
    UPLOAD_ORDERDATA(state, data) {
      state.uploadOrderResp = data
    },
    FIND_RECYCLING_ORDER_TYPE_DATA(state, data) {
      state.findRecyclingOrderTypeData = data.obj || []
    },
    SELECT_MINQTY_DATA(state, data) {
      state.selectMinqtyByCustomernoData = data.obj || 0;
    },
    FIND_VALID_ADDRS_BY_CUSTOMERCODE(state,data){
      state.consigneecAddrsObj = data.obj || {};
    },
    FIND_CONSIGNEES_BY_CUSTOMERCODE_DATA(state,data){
      state.consigneesObj = data.obj || {};
    },
    DOWN_LOAD_ORDERTEMPLATE(state, data) {
      state.templateOrderObj = data
    },
    FIND_LIST_BY_CUSTOMER_AND_SKU(state, data) {
      state.skuResp = data.obj || []
    },
    TEMPLATE_DEHIRE_DATA(state, data) {
      state.templateDehireData = data
    },
    UPLOAD_DEHIRE_DATA(state, data) {
      state.uploadDehireData = data
    },
    UPLOAD_DEHIRE_RESULT(state, data) {
      state.uploadDehireResultObj = data
    }
  },
  actions: {
    //查询事件
    async pageInfo({commit}, obj){
      let resp = await pageInfo(obj);
      commit('PAGE_INFO', resp);
    },
    //初始化页面事件
    async initPage({commit}, obj){
      let resp = await initPage(obj);
      commit('INIT_PAGE', resp);
    },
    //新增保存事件
    async saveData({commit}, obj){
      let resp = await saveData(obj);
      commit('SAVE_DATA', resp);
    },
    //初始化更新对象事件
    async initUpdate({commit}, obj){
      let resp = await initUpdate(obj);
      commit('INIT_UPDATE', resp);
    },
    //修改保存事件
    async editData({commit}, obj){
      let resp = await editData(obj);
      commit('EDIT_DATA', resp);
    },
    //删除数据事件
    async deleteData({commit}, obj){
      let resp = await deleteData(obj);
      commit('DELETE_DATA', resp);
    },

    //导出数据
    async exportData({ commit }, obj) {
      let resp = await exportData(obj);
      commit('EXPORT_DATA', resp);
    },

    //基本信息
    async orderBasicDetailsInfo({ commit }, obj) {
      let resp = await orderBasicDetailsInfo(obj);
      commit('ORDERBASIC_DETAILS_INFO', resp);
    },
    //订单数据初始化
    async initOrderApprovedData({ commit }, obj) {
      let resp = await initOrderApprovedData(obj);
      commit('ORDER_LIST', resp);
    },
    //附件下载
    async fileDownload({ commit }, obj) {
      let resp = await fileDownload(obj);
      commit('FILE_DATA', resp);
    },
    //同意
    async approveAgree({ commit }, obj) {
      let resp = await approveAgree(obj);
      commit('AGREE_DATA', resp);
    },
    //批量同意
    async batchApproveAgree({ commit }, obj) {
      let resp = await batchApproveAgree(obj);
      commit('BATCH_AGREE_DATA', resp);
    },
    //拒绝
    async refuseApproved({ commit }, obj) {
      let resp = await refuseApproved(obj);
      commit('REFUSE_DATA', resp);
    },
    async selectOrderStatus({commit}, obj){
      let resp = await selectRecyclingOrderStatus(obj);
      commit('ORDER_STATUS', resp);
    },
    async selectOrderType({commit}, obj){
      let resp = await selectOrderType(obj);
      commit('ORDER_TYPE', resp);
    },
    async selectOrderRejectReason({commit}, obj){
      let resp = await selectOrderRejectReason(obj);
      commit('ORDER_REJECT_REASON', resp);
    },
    //导入itr模版下载
    async templateItr({commit}, obj){
      let resp = await templateItr(obj);
      commit('TEMPLATE_ITR_DATA', resp);
    },
    //上传文件
    async uploadUrl({commit}, obj){
      let resp = await uploadUrl(obj);
      commit('UPLOAD_URL_DATA', resp);
    },
    //导入itr
    async uploadItr({commit}, obj){
      let resp = await uploadItr(obj);
      commit('UPLOAD_ITR_DATA', resp);
    },
    //导入导出结果
    async uploadItrResult({ commit }, obj) {
        let resp = await uploadItrResult(obj);
        commit('UPLOAD_ITR_RESULT', resp);
    },
    //dehire
    async dehire({ commit }, obj) {
      let resp = await dehire(obj);
      commit('DEHIRE_DATA', resp);
    },
    // 下载订单模板[国内订单类型]
    async templateDomesticOrder({ commit }, obj) {
      const resp = await templateDomesticOrder(obj)
      commit('DOWNLOAD_DOMESTIC_ORDERTEMPLATE', resp)
    },
    // 导入订单数据[国内订单类型]
    async uploadDomesticOrder({ commit }, obj) {
      const resp = await uploadDomesticOrder(obj)
      commit('UPLOAD_DOMESTIC_ORDERDATA', resp)
    },
    // 下载订单模板[国内订单类型]结果文件
    async uploadDomesticOrderResult({ commit }, obj) {
      const resp = await uploadDomesticOrderResult(obj)
      commit('UPLOAD_DOMESTICORDER__RESULT', resp)
    },
    // 导入订单数据
    async uploadOrder({ commit }, obj) {
      const resp = await uploadOrder(obj)
      commit('UPLOAD_ORDERDATA', resp)
    },
    // 下载订单模板
    async templateOrder({ commit }, obj) {
      const resp = await templateOrder(obj)
      commit('DOWN_LOAD_ORDERTEMPLATE', resp)
    },
    // 下载导入订单结果文件
    async uploadOrderResult({ commit }, obj) {
      const resp = await uploadOrderResult(obj)
      commit('UPLOAD_ORDER_RESULT', resp)
    },
    // 回收订单类型
    async findRecyclingOrderType({ commit }, obj) {
      const resp = await findRecyclingOrderType(obj)
      commit('FIND_RECYCLING_ORDER_TYPE_DATA', resp)
    },
    //获取订单数量
    async selectMinqtyByCustomerno({ commit }, obj) {
      let resp = await selectMinqtyByCustomerno(obj);
      commit('SELECT_MINQTY_DATA', resp);
    },
    async findValidAddrsByCustomerCode({commit}, customerCode, consigneeCode){
      let resp = await findValidAddrsByCustomerCode(customerCode, consigneeCode);
      commit('FIND_VALID_ADDRS_BY_CUSTOMERCODE', resp);
    },
    async findConsigneesByCustomerCode({commit}, obj){
      let resp = await findConsigneesByCustomerCode(obj);
      commit('FIND_CONSIGNEES_BY_CUSTOMERCODE_DATA', resp);
    },
    async findListByCustomerAndSku({commit}, obj){
      let resp = await findListByCustomerAndSku(obj);
      commit('FIND_LIST_BY_CUSTOMER_AND_SKU', resp);
    },
    //Dehire模板下载
    async templateDehire({commit}, obj){
      let resp = await templateDehire(obj);
      commit('TEMPLATE_DEHIRE_DATA', resp);
    },
    //导入Dehire
    async uploadDehire({commit}, obj){
      let resp = await uploadDehire(obj);
      commit('UPLOAD_DEHIRE_DATA', resp);
    },
    //导入Dehire结果导出
    async uploadDehireResult({commit}, obj){
      let resp = await uploadDehireResult(obj);
      commit('UPLOAD_DEHIRE_RESULT', resp);
    },
  }
}
export default salesApprove



// WEBPACK FOOTER //
// ./src/page/recovery/approve/store/recoveryApprove.store.js